import ComponentManager from '../shared/component-manager';
import TeacherField from '../shared/components/teacher-field';
import TileList from '../shared/components/tile-list';

import AvatarBuilderDescriptionModal from './components/mentee/avatar-builder-description-modal';
import BookmarkAddForm from './components/mentee/bookmark-add-form';
import BookmarkTileReloader from './components/mentee/bookmark-tile-reloader';
import InternshipRequest from './components/mentee/internship-request';
import ObjectiveFields from './components/mentee/objective-fields';

class MenteeComponentManager extends ComponentManager {
  initializeComponents() {
    this.initializeTileLists();

    AvatarBuilderDescriptionModal.initialize(
      '.menteeAvatarBuilderWelcomeModal'
    );
    AvatarBuilderDescriptionModal.initialize('.menteeAvatarBuilderEditModal');
    BookmarkAddForm.initialize('.bookmarkAddForm');
    InternshipRequest.initialize('.internshipRequest');
    TeacherField.initialize('.teacherField');
    ObjectiveFields.initialize('.menteeObjectiveFields');
  }

  initializeTileLists() {
    const options = {gutter: 20, columnWidth: 242, transitionDuration: 0};

    const bookmarksTileList = TileList.initialize('.bookmarkList', {
      itemSelector: '.bookmarkList-item',
      ...options,
    });

    TileList.initialize('.mentorList', {
      itemSelector: '.mentorList-item',
      ...options,
    });

    BookmarkTileReloader.initialize('.bookmarkList-item--unextracted', {
      tileListComponent: bookmarksTileList[0],
    });
  }
}

export const initialize = () => {
  jQuery(() => {
    new MenteeComponentManager([
      AvatarBuilderDescriptionModal,
      BookmarkAddForm,
      BookmarkTileReloader,
      InternshipRequest,
      ObjectiveFields,
      TeacherField,
      TileList,
    ]);
  });
};
